import { SettingsNavigation } from 'components/Settings';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, styled } from 'shell/components';
import { SettingsPageContext } from '../PageProvider';
import { flattenSettingsSections } from '../sectionRegistry';
import SettingsSections from '../shared/sections';

const DesktopSettings = () => {
    const { groups } = useContext(SettingsPageContext);
    const { t } = useTranslation();
    const sections = flattenSettingsSections(groups);
    const labels = Object.fromEntries([
        ...groups.map(({ id, labelKey, fallback }) => [id, t(labelKey, fallback)]),
        ...sections.map(({ id, labelKey, fallback }) => [id, t(labelKey, fallback)]),
    ]);
    return (
        <Stack
            direction='row'
            sx={{
                alignItems: 'stretch',
                backgroundColor: 'ensightful.shades.0',
                minHeight: 'calc(100vh - 180px)',
                minWidth: 0,
            }}
        >
            <SettingsNavigation
                groups={groups}
                labels={labels}
                ariaLabel={t('settings.navigation', 'Settings navigation')}
            />
            <Content>
                <SettingsSections />
            </Content>
        </Stack>
    );
};

const Content = styled(Stack)(({ theme }) => ({
    borderLeft: `1px solid ${theme.palette.ensightful.neutral[300]}`,
    minWidth: 0,
    padding: theme.spacing(5, 4),
    width: '100%',

    '& [data-settings-section]': {
        scrollMarginTop: theme.spacing(4),
    },
}));

export default DesktopSettings;
